import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryLayout7 } from '@components/gallery/components/gallery-layout-7/model';
import { ImageComponent } from '@shared/components/image';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-gallery-layout-7',
  imports: [NgTemplateOutlet, ImageComponent, VideoComponent],
  templateUrl: './gallery-layout-7.component.html',
  styleUrl: './gallery-layout-7.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout7Component {
  readonly data = input.required<GalleryLayout7>();
}
